import { createStore } from 'easy-peasy';

import AppState from './AppState';
import InfoState from './InfoState';
import IncomeState from './IncomeState';
import TooltipState from './TooltipState';

const Store = createStore({
  info: InfoState,
  app: AppState,
  income: IncomeState,
  tooltip: TooltipState
});

export default Store;
